export const FILE_EXPORT_DOC_URL =
  'https://docs.wandb.ai/library/public-api-guide#download-all-files-from-a-run';
export const MAX_NUM_FILES = 10000;
export const PAGE_SIZE = 25;
